import(/* webpackMode: "eager" */ "/vercel/path0/apps/prono-rtbf/app/prizes/page.tsx");
